import { render, staticRenderFns } from "./CompanyInformation.vue?vue&type=template&id=a9d87130&scoped=true&"
import script from "./CompanyInformation.vue?vue&type=script&lang=js&"
export * from "./CompanyInformation.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInformation.vue?vue&type=style&index=0&id=a9d87130&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d87130",
  null
  
)

export default component.exports